import type { AudienceRule } from '../../audienceRules/audience-rule'

export class PreviewOrGenerateAudienceDto {
    audienceId: string
    audienceRules: AudienceRule[]
}
